import { Controller } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { appendStringWithValue, FormatISODateTime, DateFormat, CurrencyFormat } from '../../../helpers/formatting'

export default function RefinanceForm(props) {
  const { control, responseData } = props

  return (
    <>
      <h3>
        On {FormatISODateTime(responseData?.created_at)}, Agent <Link
          to={`user/${responseData?.agent_user_id}`}
          className="is-link"
          target="_blank"
        ><b>{responseData?.agent_user_label}</b></Link> requested
        manager approval for refinance for customer <Link
          to={`customer/${responseData?.customer_id}`}
          className="is-link"
          target="_blank"
        ><b>{responseData?.customer_label}</b></Link> for
        Lead <Link
          to={`payment_schedule/${responseData?.customer_id}`}
          className="is-link"
          target="_blank"
        ><b>{responseData?.lead?.label}</b></Link> {appendStringWithValue('Principal Amount', responseData?.lead?.approved_principal)} {appendStringWithValue('Discount Principal', responseData?.lead?.discount_principal)} {appendStringWithValue('Discount Interest', responseData?.lead?.discount_interest)}.
      </h3>
      <h3>{responseData?.description}</h3>

      <div className="divider m-0 my-2"></div>

      <h3>If approving you may modify these values:</h3><br />

      <div className="field is-horizontal manager-approval-modal-field">
        <label className="manager-approval-modal-label">Discount Principal:</label>
        <div className="control">
          <Controller
            name="discount_principal"
            control={control}
            defaultValue={responseData?.lead?.discount_principal ?? 0}
            rules={{ required: true }}
            render={({ field }) => (
              <input
                {...field}
                type="number"
                className="input is-small lox-no-border"
                readOnly
                max={responseData?.lead?.max_principal_discount}
              />
            )}
          />
          <small>Max: <CurrencyFormat value={responseData?.lead?.max_principal_discount} /></small>
        </div>
      </div>

      <div className="field is-horizontal manager-approval-modal-field">
        <label className="manager-approval-modal-label">Discount Interest:</label>
        <div className="control">
          <Controller
            name="discount_interest"
            control={control}
            defaultValue={responseData?.lead?.discount_interest ?? 0}
            rules={{ required: true }}
            render={({ field }) => (
              <input
                {...field}
                type="number"
                className="input is-small lox-no-border"
                readOnly
                max={responseData?.lead?.max_interest_discount}
              />
            )}
          />
          <small>Max: <CurrencyFormat value={responseData?.lead?.max_interest_discount} /></small>
        </div>
      </div>

      {!!responseData?.lead?.additional_funds && (
        <div className="field is-horizontal manager-approval-modal-field">
          <label className="manager-approval-modal-label">Additional Funds:</label>
          <div className="control">
          <Controller
            name="additional_funds"
            control={control}
            defaultValue={responseData?.lead?.additional_funds ?? 0}
            rules={{ required: true }}
            render={({ field }) => (
              <input {...field} type="number" className="input is-small lox-no-border" readOnly />
            )}
          />
          {/* This is a slightly hacky placeholder to get everything to look the same since we are using flexbox and it was to adjust the div sizing as so */}
          <small style={{ visibility: 'hidden', whiteSpace: 'nowrap' }}>Max: <CurrencyFormat value={responseData?.lead?.additional_funds} /></small>
          </div>
        </div>
      )}

      <div className="field is-horizontal manager-approval-modal-field">
        <label className="manager-approval-modal-label">APR:</label>
        <div className="control">
          <Controller
            name="apr"
            control={control}
            defaultValue={responseData?.lead?.apr ?? 0}
            rules={{ required: true }}
            render={({ field }) => (
              <input
                {...field}
                type="number"
                className="input is-small lox-no-border"
                readOnly
                step="0.001"
              />
            )}
          />
          {/* This is a slightly hacky placeholder to get everything to look the same since we are using flexbox and it was to adjust the div sizing as so */}
          <small style={{ visibility: 'hidden', whiteSpace: 'nowrap' }}>Max: <CurrencyFormat value={responseData?.lead?.apr} /></small>
        </div>
      </div>
    </>
  )
}
